import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Spinner,
    Table
} from "reactstrap";

import {
    Eye,
    Users,
    Activity,
    User
} from "lucide-react";

import {
    useEffect,
    useState
} from "react";

import {
    DashboardDto
} from "../types/analyticsTypes";

import {
    getDashboard
} from "../services/analyticsService";
import StatCard from "../components/StatCard";
import TopPagesTable from "../components/TopPagesTable";

function Analytics() {

    const [
        dashboard,
        setDashboard
    ] = useState<DashboardDto>();

    const [
        loading,
        setLoading
    ] = useState(true);

    useEffect(() => {

        load();

    }, []);

    async function load() {

        try {

            const result =
                await getDashboard();

            setDashboard(result);

        }
        finally {

            setLoading(false);

        }

    }

    if (loading)
        return (
            <div className="text-center mt-5">
                <Spinner />
            </div>
        );

    return (

        <Container
            fluid
            className="mt-4"
        >

            <h2 className="fw-bold mb-4">
                Analytics Dashboard
            </h2>


            <Row className="g-4">

                <Col lg="3">

                    <StatCard
                        title="Total Visits"
                        value={dashboard?.totalVisits ?? 0}
                        icon={Eye}
                        color="#0d6efd"
                    />

                </Col>

                <Col lg="3">

                    <StatCard
                        title="Unique Visitors"
                        value={dashboard?.uniqueVisitors ?? 0}
                        icon={Users}
                        color="#198754"
                    />

                </Col>

                <Col lg="3">

                    <StatCard
                        title="Today's Visits"
                        value={dashboard?.todayVisits ?? 0}
                        icon={Activity}
                        color="#fd7e14"
                    />

                </Col>

                <Col lg="3">

                    <StatCard
                        title="Today's Visitors"
                        value={dashboard?.todayVisitors ?? 0}
                        icon={User}
                        color="#dc3545"
                    />

                </Col>

            </Row>

            <Row className="mt-4">

                <Col>

                    <TopPagesTable
                        pages={dashboard?.topPages ?? []}
                    />

                </Col>

            </Row>

        </Container>

    );

}

export default Analytics;